import { render, staticRenderFns } from "./support-message-icon.vue?vue&type=template&id=2dcd981e&"
import script from "./support-message-icon.vue?vue&type=script&lang=js&"
export * from "./support-message-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports